export default __webpack_public_path__ + "static/media/uk.e0f01f35.svg";